
import { Component, Ref, Prop, Vue } from 'vue-property-decorator'
import { SystemChart } from '@/models/SystemChart'
import SelectModal from '@/components/templates/SelectModal.vue'

/**
 * 単元の系統図選択モーダル
 */
@Component({
  components: {
    SelectModal,
  },
})
export default class ModalSelectChart extends Vue {
  /** 選択用モーダル */
  @Ref()
  private selectModal!: SelectModal

  /** ボタン押下時のイベント */
  @Prop()
  private eventSubmitSystemChart!: (id: number) => void

  /** 系統図のリスト */
  @Prop()
  public systemChartList!: SystemChart[]

  /**
   * 系統図ID一覧(IDを引き当てコードとして使用する)
   *
   * @returns 系統図IDのリスト(文字列形式)
   */
  private get systemChartIdList(): string[] {
    return this.systemChartList.map((chart) => `${chart.id}`)
  }

  /**
   * ボタン押下時のイベント
   */
  private submitSystemChart(): void {
    this.selectModal.hide()
    this.eventSubmitSystemChart(Number(this.selectModal.currentItemCode))
  }

  /**
   * 系統図IDからラベルを引当てて返す
   *
   * @param id 系統図ID(文字列型)
   * @returns 系統図のラベル
   */
  private getLabelById(id: string): string {
    const label = this.systemChartList.find((chart) => `${chart.id}` === id)?.name
    return label || ''
  }

  /**
   * モーダルを開く
   *
   * @param id 現在の系統図ID
   */
  public show(id: number): void {
    this.selectModal.show(`${id}`)
  }
}
